import React, { Component } from 'react';
import { ProductConsumer } from "../context";
import styled from "styled-components";

export default class ExtraToppingChoice extends Component {
    
    render(){
        return(
            <ProductConsumer>
			{(value) => {
                const { handleInputChange,ekstras} = value;


				return (
					<ExtraToppingChoiceWrapper className="">
					
                <div className="container">
                    <div className="col">
                        <br /><br />
                        <h3>Topping</h3><br />
                        
                        <div className="form-row">
                            <div className="form-group col-md-6">
                               
                               {ekstras.map((item) => {
                                   return <div key={item.tname} className="form-check form-check-inline"style={{width:130}}>
                                            <input  className="form-check-input" type="checkbox" name={item.tname} id="inlineCheckboxh" value={item.tname} onChange={handleInputChange} />
                                            <label className="form-check-label" htmlFor="inlineCheckboxh1">{item.tname}</label>
                                         </div>
                               })}
            
                            </div>
                        </div>               
                    </div>
                </div>
            
					</ExtraToppingChoiceWrapper>
				);
			}}
		</ProductConsumer>
           
        )  
    }
}
const ExtraToppingChoiceWrapper = styled.div`
.ekstra{
    width:200px;
}
`;